const normalizeCountry = (c) => {
  const code = (c || '').trim().toLowerCase();
  return code === 'gb' ? 'uk' : code;
};

export function isPickupPointCountry(country) {
  const enabled = (process.env.REACT_APP_PICKUP_POINT_COUNTRIES || '')
    .split(',')
    .map(normalizeCountry)
    .filter(Boolean);
  return enabled.includes(normalizeCountry(country));
}

export function isPickupPointAddress(addr) {
  return !!(addr && addr.pudo && addr.pudo.lockerId);
}

export function pickupPointToAddress(selection, defaultAddress = {}) {
  const raw = (selection && selection.raw) || {};
  const name =
    raw.name || (raw.contactInfo && raw.contactInfo.name) || selection.address;

  const base = { ...defaultAddress };
  delete base.id;
  delete base.rndId;
  delete base.isNew;

  return {
    ...base,
    label: name,
    defaultAddress: false,
    pudo: {
      lockerId: String(selection.id || raw.id || ''),
      provider: selection.provider || '',
    },
  };
}
